export const LOGIN_COOKIE_NAME = 'UserData'
export const LEGACY_LOGIN_COOKIE_NAME = 'LogUser'

export const LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS = 60

export const LOGIN_MOTIVATION = {
  pta: {
    text: 'LOGIN_CONTAINER_COCHES_MOTIVATION_PTA_TEXT'
  },
  default: {
    text: 'LOGIN_CONTAINER_COCHES_MOTIVATION_DEFAULT_TEXT'
  }
}

export const IS_GOT_ENABLED = true
export const GIGYA_SCREEN_CONTAINER_ID = 'gigya-default-container'
export const LOGIN_IDS = {
  standard: 'STANDARD',
  google: 'GOOGLE',
  apple: 'APPLE'
}

const GIGYA_LOGIN_STANDARD_PROVIDER_KEY = 'site'
const GIGYA_LOGIN_GOOGLE_PROVIDER_KEY = 'googleplus'
const GIGYA_LOGIN_APPLE_PROVIDER_KEY = 'apple'

export const GIGYA_LOGIN_PROVIDERS = {
  [LOGIN_IDS.standard]: GIGYA_LOGIN_STANDARD_PROVIDER_KEY,
  [LOGIN_IDS.google]: GIGYA_LOGIN_GOOGLE_PROVIDER_KEY,
  [LOGIN_IDS.apple]: GIGYA_LOGIN_APPLE_PROVIDER_KEY
}

// Login and register images and descriptions
export const DEFAULT_LOGIN_SOURCE_ID = 'default'
export const LOGIN_SOURCE_ID_CREATE_ALERT = 'create-alert'
export const LOGIN_SOURCE_ID_ADD_FAV = 'add-favourite'
export const LOGIN_SOURCE_ID_DEALER_FAV = 'dealer-favourite'
export const LOGIN_SOURCE_ID_CREATE_NEWS_COMMENT = 'create-news-comment'
export const LOGIN_SOURCE_ID_SUBSCRIBE_NEWSLETTER = 'subscribe-newsletter'
export const LOGIN_SOURCE_ID_LEAD = 'lead'
export const LOGIN_SOURCE_ID_WHATSAPP_LEAD = 'whatsapp-lead'
export const LOGIN_SOURCE_ID_APPRAISER = 'appraiser-form-submit'
export const LOGIN_SOURCE_ID_DISCARD_AD = 'discard-ad'
export const LOGIN_SOURCE_ID_PUBLISH_AD = 'publish-ad'
export const LOGIN_SOURCE_ID_RESERVATIONS = 'reservations'
export const LOGIN_SOURCE_ID_TRANSACTONS = 'transactions'
export const LOGIN_SOURCE_ID_VEHICLE_CONFIGURATOR = 'vehicle-configurator'
export const LOGIN_SOURCE_ID_SAVE_NEWS = 'save-news'
export const LOGIN_SOURCE_ID_HOME_POST_CONSENT = 'home-post-consent'

export const LOGIN_SOURCES = {
  [LOGIN_SOURCE_ID_CREATE_ALERT]: {
    description: 'LOGIN_VALUE_ACTIONS.CREATE_ALERT',
    image: 'images/illustrations/coches-value-action-alert.svg'
  },
  [LOGIN_SOURCE_ID_ADD_FAV]: {
    description: 'LOGIN_VALUE_ACTIONS.ADD_FAVOURITE',
    image: 'images/illustrations/coches-value-action-favourite.svg'
  },
  [LOGIN_SOURCE_ID_DEALER_FAV]: {
    description: 'LOGIN_VALUE_ACTIONS.DEALER_FAVOURITE',
    image: 'images/illustrations/coches-value-action-favourite.svg'
  },
  [DEFAULT_LOGIN_SOURCE_ID]: {
    description: 'LOGIN_VALUE_ACTIONS.DEFAULT',
    image: 'images/illustrations/coches-value-action-default.svg'
  },
  [LOGIN_SOURCE_ID_CREATE_NEWS_COMMENT]: {
    description: 'LOGIN_VALUE_ACTIONS.CREATE_NEWS_COMMENT',
    image: 'images/illustrations/comments.svg'
  },
  [LOGIN_SOURCE_ID_SUBSCRIBE_NEWSLETTER]: {
    description: 'LOGIN_VALUE_ACTIONS.SUBSCRIBE_NEWSLETTER',
    image: 'images/illustrations/newsletter.svg'
  },
  [LOGIN_SOURCE_ID_LEAD]: {
    description: 'LOGIN_VALUE_ACTIONS.LEAD',
    image: 'images/illustrations/coches-value-action-default.svg'
  },
  [LOGIN_SOURCE_ID_WHATSAPP_LEAD]: {
    description: 'LOGIN_VALUE_ACTIONS.WHATSAPP_LEAD',
    image: 'images/illustrations/coches-value-action-default.svg'
  },
  [LOGIN_SOURCE_ID_APPRAISER]: {
    description: 'LOGIN_VALUE_ACTIONS.APPRAISER_FORM_SUBMIT',
    image: 'images/illustrations/coches-value-action-appraiser.svg'
  },
  [LOGIN_SOURCE_ID_DISCARD_AD]: {
    description: 'LOGIN_VALUE_ACTIONS.DISCARD_AD',
    image: 'images/illustrations/common-value-action-discard-ad.svg'
  },
  [LOGIN_SOURCE_ID_RESERVATIONS]: {
    description: 'LOGIN_VALUE_ACTIONS.RESERVATIONS',
    image: 'images/illustrations/vn-new-vehicle.svg',
    verification: {
      description: 'LOGIN_VALUE_ACTIONS.VERIFICATION_REMINDER',
      image: 'images/sent-message.svg'
    }
  },
  [LOGIN_SOURCE_ID_PUBLISH_AD]: {
    description: 'LOGIN_VALUE_ACTIONS.PUBLISH_AD',
    image: 'images/illustrations/seller-publish-ad.svg'
  },
  [LOGIN_SOURCE_ID_TRANSACTONS]: {
    description: 'LOGIN_VALUE_ACTIONS.TRANSACTIONS',
    image: 'images/illustrations/vn-new-vehicle.svg'
  },
  [LOGIN_SOURCE_ID_VEHICLE_CONFIGURATOR]: {
    description: 'LOGIN_VALUE_ACTIONS.VEHICLE_CONFIGURATOR',
    image: 'images/illustrations/vn-new-vehicle.svg'
  },
  [LOGIN_SOURCE_ID_SAVE_NEWS]: {
    description: 'LOGIN_VALUE_ACTIONS.SAVE_NEWS',
    image: 'images/illustrations/save-news-for-later-register-coches.svg'
  },
  [LOGIN_SOURCE_ID_HOME_POST_CONSENT]: {
    description: 'LOGIN_VALUE_ACTIONS.HOME_POST_CONSENT',
    image: 'images/illustrations/coches-value-action-default.svg'
  }
}
